'use strict';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/delay';
import 'rxjs/add/observable/merge';
import React, {Component} from 'react';
import * as T from 'prop-types';
import {getId} from '../../../core-utilities/domain/ReduxUtils';
import {epicErrorHandler} from '../../../core-utilities/rx-utils/index';
import {getUserId} from '../../../auth/reducers';
import {Avatar} from '../../../files/components/Avatar';
import {UserProfileView} from './UserProfileView';
import {logger} from '../logger';


export const modalOptions = {
  isLegacy: true,
  modalProps: {
    modalClass: 'UserProfileModal',
    useScrollWrapper: true,
  },
};

/**
 * HACK: UserProfileComponent.actions is temporary until a generalized UpdateModalHOC is created
 */
export class UserProfileComponent extends Component {
  static propTypes = {
    onSuccess: T.func/* .isRequired*/,
    onCancel: T.func/* .isRequired*/,
  };

  static $inject = [
    '$ngRedux',
    'PersonDomain',
  ];

  constructor(props) {
    super(props);
    this.state = {
      name: '',
      isChangingName: false,
      nameError: null,
      firstName: '',
      isChangingFirstName: false,
      firstNameError: null,
      lastName: '',
      isChangingLastName: false,
      lastNameError: null,

      // updateProfile state
      isFetching: false,
      showSuccess: false,
      showModal: true,
      err: null,
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChangeName = this.handleChangeName.bind(this);
    this.handleChangeFirstName = this.handleChangeFirstName.bind(this);
    this.handleChangeLastName = this.handleChangeLastName.bind(this);
  }

  handleSave(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.props.isSaveDisabled || this.props.isFetching)
      return;

    const body = {};

    if (this.state.isChangingName) {
      body.name = this.state.name;
    }

    if (this.state.isChangingFirstName) {
      body.firstName = this.state.firstName;
    }

    if (this.state.isChangingLastName) {
      body.lastName = this.state.lastName;
    }

    if (Object.keys(body).length > 0) {
      const data = {
        id: getUserId(UserProfileComponent.dependencies.$ngRedux.getState()),
      };

      UserProfileComponent.dependencies.$ngRedux.dispatch(UserProfileComponent.actions.sendRequest({body, data}));
    }
  }

  handleCancel(e) {
    e.preventDefault();
    e.stopPropagation();
    if (isFunction(this.props.onCancel)) {
      this.props.onCancel();
    }
  }

  handleChangeName(event) {
    this.handleValueChange(event, 'name', 'isChangingName', 'nameError');
  }

  handleChangeFirstName(event) {
    this.handleValueChange(event, 'firstName', 'isChangingFirstName', 'firstNameError');
  }

  handleChangeLastName(event) {
    this.handleValueChange(event, 'lastName', 'isChangingLastName', 'lastNameError');
  }

  /**
   * @param event
   * @param {String} valueProp - The name of the profile property to change
   * @param {String} toggleProp - The name of the state property indicating change is in progress
   * @param {String} errorProp - The name of the state property for the validation error message
   */
  handleValueChange(event, valueProp, toggleProp, errorProp) {
    const prevValue = get(this.state.profile, valueProp, '');
    const nextValue = event.target.value;
    const isToggled = prevValue !== nextValue;

    this.setState({
      [valueProp]: isToggled ? nextValue : prevValue,
      [toggleProp]: isToggled,
      [errorProp]: !event.target.isValid,
    });
  }

  isSaveDisabled() {
    return !!(this.state.nameError || this.state.firstNameError || this.state.lastNameError)
      || (!this.state.isChangingName && !this.state.isChangingFirstName && !this.state.isChangingLastName);
  }

  render() {
    return (
      <UserProfileView
        email={this.state.email}
        name={get(this.state.profile, 'name', '')}
        firstName={get(this.state.profile, 'firstName', '')}
        lastName={get(this.state.profile, 'lastName', '')}

        onClickSave={this.handleSave}
        onClickCancel={this.handleCancel}
        onChangeName={this.handleChangeName}
        onChangeFirstName={this.handleChangeFirstName}
        onChangeLastName={this.handleChangeLastName}
        isSaveDisabled={this.isSaveDisabled()}
        isFetching={this.state.isFetching}
        showSuccess={this.state.showSuccess}

        avatar={
          <Avatar
            className={UserProfileView.avatarClass}
            iconClass={UserProfileView.avatarIconClass}
            model={this.state.profile}
            targetWidth={80}
            targetHeight={80}
            cropTarget={true}
          />
        }
      />
    );
  }

  componentDidMount() {
    const userEmail$ = UserProfileComponent.dependencies.$ngRedux.state$
      .distinctUntilChanged(null, state => state.model.user && state.model.user.email)
      .map(state => ({email: state.model.user ? state.model.user.email : ''}));
    const profile$ = UserProfileComponent.dependencies.$ngRedux.state$
      .distinctUntilChanged(null, state => state.model.user)
      .switchMap(state => UserProfileComponent.observeProfile(state.model.user))
      .map(profile => ({profile}));

    this.stateSubscription = Observable
      .merge(
        userEmail$,
        profile$,
      )
      .catch(epicErrorHandler(logger, 'state$'))
      .delay(0)
      .subscribe(nextState => this.setState(nextState));
  }

  componentWillUnmount() {
    this.stateSubscription && this.stateSubscription.unsubscribe();
  }

  static observeProfile(user) {
    const profileId = getId(user);
    if (profileId) {
      return Observable
        .fromPromise(UserProfileComponent.dependencies.PersonDomain.$get(profileId))
        .switchMap(profile => isObject(profile) ? profile.$observe() : Observable.of(null))
        /* TODO: inform the user */
        .catch(() => Observable.of(null));
    } else {
      return Observable.of(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/user-profile/compoments/UserProfile/UserProfileComponent.js